import {message} from "antd";
import {useAuth} from "oidc-react";
import React from "react";
import {Navigate, useNavigate} from "react-router-dom";
import {RoutingPaths} from "../../routing/routingContainer";
import ForgotPassword from "./forgotPassword";
import {useInjection} from "inversify-react";
import ApiService from "../../../services/apiService";
import {ApplicationUserApi, StartForgotPasswordDto} from "../../../api";

export default function ForgotPasswordContainer() {
    const auth = useAuth();
    const navigate = useNavigate();
    const apiService = useInjection(ApiService);

    if (auth.userData) {
        return <Navigate to={RoutingPaths.mainPage.route} replace={true}/>;
    }

    const onSubmit = async (value: StartForgotPasswordDto): Promise<any> => {
        message.info("Jeśli podany adres e-mail należy do konta, otrzymasz wiadomość e-mail z instrukcjami, " +
            "jak zresetować hasło.");
        try {
            await  apiService.getApi(ApplicationUserApi).apiApplicationUserBeginForgotPasswordPost(value);
        } catch (e: any) {
            console.log(e);
            return e.response?.data;
        }

        navigate(RoutingPaths.login.route, {replace: true});
    }

    return <>
        <ForgotPassword onSubmit={onSubmit}/>
    </>;
}
